export enum ProofOfWorkError {
  UNKNOWN = 1,
  REQUEST_INVALID = 2,
  SESSION_INACTIVE = 3
}

export type VerifyPuzzleReturnType = {
  answerCorrect: boolean;
  redemptionToken: string;
  message: string;
};

export type GetPuzzleReturnType = {
  puzzleType: string;
  artifact: string;
};
